export const apiEndpoint = import.meta.env.VITE_API_ENDPOINT;
